import React, { lazy, Suspense } from 'react';
import { MainContentContainer } from '../../Routes/OtherPages.styles';
import CoursesDataProvider from '../../Utils/Courses/CoursesDataProvider';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
const SideContainerComponent = lazy(
  () => import('../../Routes/SideContainer.component')
);
import CourseCatalog from './CourseCatalog/CourseCatalog.component';

const OnlineTraining = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Online Safety Courses & Workplace Training"
        description="Explore online workplace safety courses and training in Canada. Complete WHMIS, TDG, Fall Protection and other safety training online at your own pace."
      />
      <Suspense fallback={<p>Loading page...</p>}>
        <SideContainerComponent />
        <CoursesDataProvider>
          {(courses) => {
            return <CourseCatalog courses={courses} />;
          }}
        </CoursesDataProvider>
      </Suspense>
    </MainContentContainer>
  );
};

export default OnlineTraining;
